const getCustomTicketGender = (customLabel: string | null) => {
  if (!customLabel) {
    return 'a';
  }
  if (customLabel.endsWith('o')) {
    return 'o';
  }
  if (customLabel.endsWith('a')) {
    return 'a';
  }
  return 'a';
};

export default getCustomTicketGender;
